module.exports = __webpack_public_path__ + "static/img/db-life-img-06@w.2ca1f64.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/db-life/db-life-img-06@w.jpg
// module id = 9bWX
// module chunks = 0